var _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPressure = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  points: "11.90685 14 9.95425 12.0474 8.78091 13.22074 7.15656 7.15656 13.22074 8.78091 12.0474 9.95425 14 11.90685 11.90685 14"
})), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
  points: "6.84344 6.84344 .77926 5.21909 1.9526 4.04575 0 2.09315 2.09315 0 4.04575 1.9526 5.21909 .77926 6.84344 6.84344"
})));
export default SvgPressure;